import React, {FunctionComponent} from "react";

interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = ({}) => {
  return (
    <div className='items-end flex flex-1 justify-between pb-4 pt-8 px-8'>
      <div className='flex-1'></div>

      <div className='text-center flex-1'>
        <span className='text-gray-600'>&copy; Ella Luhtasaari {(new Date()).getFullYear()}</span>
      </div>

      <div className='flex-1 text-right'>
        <span className='text-gray-600 text-xs'>{process.env.GIT_COMMIT_SHORT}</span>
      </div>
    </div>
  )
}

export default Footer;
